export class UnauthorizedError extends Error {
  override readonly name = 'UnauthorizedError';
  constructor() {
    super('Unauthorized');
  }
}

export class NetworkError extends Error {
  override readonly name = 'NetworkError';
  constructor() {
    super('Network error');
  }
}

export class ServerError extends Error {
  override readonly name = 'ServerError';
  constructor() {
    super('Server error');
  }
}

export class InvalidWeightInputError extends Error {
  override readonly name = 'InvalidWeightInputError';
  constructor(message = 'Invalid weight input') {
    super(message);
  }
}

export class WeightEntryNotFoundError extends Error {
  override readonly name = 'WeightEntryNotFoundError';
  constructor(message = 'Weight entry not found') {
    super(message);
  }
}

export class InvalidDateRangeError extends Error {
  override readonly name = 'InvalidDateRangeError';
  constructor(message = 'Invalid date range') {
    super(message);
  }
}

export type WeightTrackingError =
  | UnauthorizedError
  | NetworkError
  | ServerError
  | InvalidWeightInputError
  | WeightEntryNotFoundError
  | InvalidDateRangeError;
